import {
  FeedstockCharacteristics,
  FeedstockCharacteristicsPropName
} from '../../../../models/project/feedstock/feedstock-characteristics.model';
import { ProjectValidationUnit } from '../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../unit-value.validation';
import Utils from '../../../../util';

export class FeedstockCharacteristicsValidation {
  /** The current feedstock characteristics obj that is being validated */
  characteristics: FeedstockCharacteristics;
  /**
   * Determines if the feedstock will use database values, this alters what inputs are required for the project
   * to be valid.
   */
  useDatabase: boolean;

  /**
   * Sets the feedstock characteristics that will be used for validation
   * @param characteristics will be used to set the current feedstock characteristics
   * @param useDatabase is a boolean that determines if database values will be used to make some
   * inputs optional.
   */
  constructor(characteristics: FeedstockCharacteristics, useDatabase: boolean) {
    if (!characteristics) throw Error('invalid feedstock characteristics provided for validation');
    this.useDatabase = useDatabase;
    this.characteristics = new FeedstockCharacteristics(characteristics);
  }

  /**
   * Get a validation unit containing the validation data for the current feedstock characteristics obj
   */
  getValidation(): ProjectValidationUnit {
    if (!this.characteristics) throw Error('unable to validate feedstock characteristics');
    const validationUnit = new ProjectValidationUnit();
    // optional if using database values for the feedstock.
      validationUnit.addModuleResults(
          new UnitValueValidation(this.characteristics.ts).getValidation(),
          FeedstockCharacteristicsPropName.ts
        );
      validationUnit.addModuleResults(
          new UnitValueValidation(this.characteristics.vs).getValidation(),
          FeedstockCharacteristicsPropName.vs
        );
    if (this.characteristics.densityEnabled) {
      validationUnit.addModuleResults(
        new UnitValueValidation(this.characteristics.density).getValidation(),
        FeedstockCharacteristicsPropName.density
      );
    }
    if (this.characteristics.codEnabled) {
      validationUnit.addModuleResults(
        new UnitValueValidation(this.characteristics.cod).getValidation(),
        FeedstockCharacteristicsPropName.cod
      );
    }
    if (validationUnit.validFields === 0 && validationUnit.invalidFields === 0) {
      validationUnit.setValid('VALIDATION.NO_REQUIRED');
    }
    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current feedstock characteristics obj is valid
   */
  isValid(): boolean {
    return this.getValidation().isValid;
  }

  private tsHasData() {
      if (this.characteristics && this.characteristics.ts) {
        return Utils.isNumeric(this.characteristics.ts.value);
      }
  }

  private vsHasData() {
    if (this.characteristics && this.characteristics.vs) {
      return Utils.isNumeric(this.characteristics.vs.value);
    }
  }
}
